import clevertap from "clevertap-web-sdk";
import EnvironmentService from "service/environment/EnvironmentService";

/**
 * Bridge's A/B CleverTap account (bridge App.js initializeCleverTapAB) — the one
 * bridge's health plan publishes its 02XXAB "ZYLA_HealthPlan" event to.
 *
 * Bridge initialises it for every session at start-up. phr initialises it on
 * first call — made by the health plan screen of a PRODUCTION 02XXAB patient
 * when it opens — so no other session talks to CleverTap. Same account ids,
 * region ("in1") and privacy flags (not opted out, IP not shared) as bridge.
 */
const AB_PRODUCTION = "6KK-WK4-695Z";
const AB_TEST = "TEST-7KK-WK4-695Z";

let initialised = false;

const cleverTapAB = () => {
  if (!initialised) {
    const production = new EnvironmentService().isProduction();
    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.init(production ? AB_PRODUCTION : AB_TEST, "in1");
    initialised = true;
  }
  return clevertap;
};

export default cleverTapAB;
